import { motion } from "framer-motion";
import { ArrowDownRight } from "lucide-react";

const line = {
  hidden: { y: "110%" },
  show: (i) => ({
    y: "0%",
    transition: { duration: 1, delay: 0.15 + i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

const fade = {
  hidden: { opacity: 0, y: 20 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: 0.75 + i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

const META = [
  "15+ års digital ledelse",
  "E-commerce & Omnichannel",
  "Aarhus · Danmark",
];

export const Hero = () => {
  const go = (href) => {
    const t = document.querySelector(href);
    if (t && window.__lenis) window.__lenis.scrollTo(t, { duration: 1.3 });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full bg-[#ffffff] flex flex-col justify-between pt-36 pb-10 overflow-hidden"
    >
      {/* subtle green accent line top-right */}
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
        className="absolute top-28 right-6 md:right-12 h-px w-24 md:w-40 bg-[#1f3d2b] origin-right"
      />

      <div className="mx-auto w-full max-w-[1400px] px-6 md:px-12">
        <motion.p
          custom={0}
          variants={fade}
          initial="hidden"
          animate="show"
          className="font-ui text-[11px] md:text-xs uppercase tracking-[0.34em] text-[#1f3d2b] mb-8"
        >
          E-commerce & Omnichannel-ekspert
        </motion.p>

        <h1 className="font-display font-light text-[#141414] leading-[0.9] text-[17vw] md:text-[14vw] lg:text-[11rem]">
          {["Morten", "Junge", "Bertelsen"].map((w, i) => (
            <span key={w} className="mask-line">
              <motion.span
                className="block"
                custom={i}
                variants={line}
                initial="hidden"
                animate="show"
              >
                {w}
              </motion.span>
            </span>
          ))}
        </h1>

        <div className="mt-10">
          <motion.p
            custom={1}
            variants={fade}
            initial="hidden"
            animate="show"
            className="max-w-xl font-ui text-base md:text-lg text-[#5a5a56] leading-relaxed text-balance"
          >
            15+ års digital ledelse — fra strategi til eksekvering. Jeg bygger
            skalerbare digitale forretninger, der skaber målbar vækst på tværs af
            kanaler.
          </motion.p>

          <motion.div
            custom={2}
            variants={fade}
            initial="hidden"
            animate="show"
            className="mt-8 flex flex-wrap items-center gap-5"
          >
            <button
              data-testid="hero-cta-contact"
              onClick={() => go("#kontakt")}
              className="group inline-flex items-center gap-3 bg-[#1f3d2b] text-white font-ui text-sm uppercase tracking-[0.18em] px-8 py-4 hover:bg-[#2f5741] transition-colors duration-300"
            >
              Lad os tale sammen
              <ArrowDownRight
                size={18}
                className="group-hover:translate-x-1 group-hover:translate-y-1 transition-transform duration-300"
              />
            </button>
            <button
              data-testid="hero-cta-results"
              onClick={() => go("#resultater")}
              className="inline-flex items-center font-ui text-sm uppercase tracking-[0.18em] text-[#141414] border-b border-[#bfbfba] pb-1 hover:text-[#1f3d2b] hover:border-[#1f3d2b] transition-colors duration-300"
            >
              Se resultater
            </button>
          </motion.div>
        </div>
      </div>

      {/* bottom meta bar */}
      <motion.div
        custom={3}
        variants={fade}
        initial="hidden"
        animate="show"
        className="mx-auto w-full max-w-[1400px] px-6 md:px-12"
      >
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-[#e4e4e1] pt-6">
          {META.map((m, i) => (
            <div
              key={m}
              className="font-ui text-xs uppercase tracking-[0.2em] text-[#6f6f6a] flex items-center gap-3"
            >
              <span className="text-[#1f3d2b]">0{i + 1}</span>
              {m}
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};
